export default __webpack_public_path__ + "static/media/44_nina.81512f51.JPG";